import { createRestApiClient } from '..';
import { getUserToken, isIOSAppUser } from '../../Utils/helper';

import { fireEvent } from '../../Utils/fireEvent';
const restApiClient = createRestApiClient();

export const formSubmit = async (params, iOSData, country_code) => {
  const url = `api/forms`;
  // if (window.location.search != "") {
  //     params["query_string"] = window.location.search;
  // }
  let iosUserData = {};
  if (isIOSAppUser()) {
    iosUserData = iOSData;
  }
  const data = await restApiClient
    .request({
      method: 'POST',
      url: url,
      data: params,
      headers: {
        authorization: isIOSAppUser()
          ? `Bearer ${iosUserData?.guid}`
          : getUserToken(),
        country_code: country_code,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      fireEvent({
        category: 'api_error',
        error: err?.message,
        req: err?.config?.url,
      });
    });
  return data;
};
export const formFetcher = async (params, formId) => {
  const url = `api/forms/${formId}`;
  if (typeof window !== 'undefined') {
    params['query_string'] = window.location.search;
  }
  const data = await restApiClient
    .request({
      method: 'GET',
      url: url,
      params: params,
      headers: {
        authorization: getUserToken(),
      },
    })
    .then((res) => res.data);
  return data;
};
